

































import {Component, Vue} from 'vue-property-decorator';
import {TranslateResult} from 'vue-i18n';
import {gsap, ScrollTrigger} from '@/utils/gsap';

@Component({})
export default class Benefits extends Vue {

	sw: any[] = [];

	$refs: {
		benefits: HTMLElement,
		benefitItem: HTMLElement[]
	}

	getGift(item: any): any {
		return {
			default: process.env.ASSET_BASE + require(`@/images/benefits/${item.gif}.gif`),
			retina: process.env.ASSET_BASE + require(`@/images/benefits/${item.gif}.gif`)
		}
	}

	get benefits(): TranslateResult {
		return this.$t('benefits');
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		this.scrollAnimation();
	}

	scrollAnimation(): void {

		let tl = gsap.timeline({paused: true});

		tl
			.to(this.$refs.benefitItem, {
				stagger: 0.15,
				className: '+=benefits__item benefits__item--active'
			})
			.to(this.$refs.benefitItem, {
				stagger: 0.15,
				className: 'benefits__item'
			});

		let sw = ScrollTrigger.create({
			trigger: this.$refs.benefits,
			start: 'top 50%',
			end: 'bottom 50%',
			onEnter: () => tl.play(),
			onEnterBack: () => tl.progress(0).play()
		});

		this.sw.push(sw);
	}

	beforeDestroy() {
		if (this.sw.length === 0 || typeof this.sw === 'undefined') {
			return;
		}
		this.sw.forEach((scrollTrigger: any) => scrollTrigger.kill());
	}

}
